import React, { useCallback, useEffect } from 'react';
import TranslatorManager from 'ts-translate-js';
import { Combo } from '../../atoms';
import './ticket-qty-selector.scss';

const tr = TranslatorManager.boundTR;

type ComboQtySelectionProps = {
    maxQty: number;
    limitQtySales: number;
    suggestedQtySales: number;
    internetTicketQTYMultipleOf: number;
    defaultValue: number;
    onQtyChange: (qty:number) => void;
    onContentChange?: Function;
}

export function TicketQtySelector({maxQty, limitQtySales, suggestedQtySales, internetTicketQTYMultipleOf, defaultValue, onQtyChange, onContentChange}: ComboQtySelectionProps) {
    const [qty, setQty] = React.useState(defaultValue);

    useEffect(() => {
        const qtyMultipleOf = (internetTicketQTYMultipleOf > 0 ? internetTicketQTYMultipleOf : 1);

        if(suggestedQtySales > maxQty * qtyMultipleOf)
            setQty(suggestedQtySales);

        if(onContentChange !== undefined) onContentChange();
    }, [internetTicketQTYMultipleOf, suggestedQtySales, maxQty, onContentChange, setQty]);

    const handleOnChangeQty = useCallback((e: React.ChangeEvent<HTMLSelectElement>) => {
        if(e.currentTarget) {
            setQty(parseInt(e.currentTarget.value));
            onQtyChange(parseInt(e.currentTarget.value));
        }

    }, [setQty, onQtyChange]);

    const renderQtyCtrl = () => {
        const qtyMultipleOf = (internetTicketQTYMultipleOf > 0 ? internetTicketQTYMultipleOf : 1);

        let totalMaxQty = maxQty * qtyMultipleOf;

        if(limitQtySales > 0 && limitQtySales <= totalMaxQty)
            totalMaxQty = limitQtySales;

        //TODO: limitMax is not used anywhere here. Remove it?
        // const qtyThresshold = 10 * qtyMultipleOf;
        // const limitMax = limitQtySales > qtyThresshold ? qtyThresshold : limitQtySales;
        
        // ----- Old version from above statement -----
        // let limitMax = limitQtySales;
        // if(limitMax > 10 * qtyMultipleOf)
        //     limitMax = 10 * qtyMultipleOf; // quand la limite est vraiment exagérer on permet 10 à la fois

        const items = [];
        //TODO: Refactor this loop to use Array.from() or Array.fill() instead of for loop
        // eslint-disable-next-line no-loops/no-loops
        for(let i = 0; i <= totalMaxQty; i=i+qtyMultipleOf) {
            items.push({ID: i, Name: i});
        }

        const qtyctrl = <Combo className="form-control" valueField="ID" 
                            textField="Name" 
                            selectedValue={qty} 
                            items={items} 
                            emptyComboMessage={tr("program.eventdateinfo.nodateavailable")}
                            onChange={handleOnChangeQty} 
                        />;

      return qtyctrl;  
    };

    return <>
        {renderQtyCtrl()}
    </>;
}
